import { useInfiniteQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { JobChangeProcessesResponse, Request } from '../types/JobChangeProcess';
import { fetchJson } from '@/utils/apiFetch';

const buildQueryParams = (query: Request, page: number): string => {
  const params = { ...query, page };
  return qs.stringify(params, { arrayFormat: 'brackets' });
};

export default function useFetchJobChangeProcessesInfinite(
  searchQuery: Request,
  options?: { enabled?: boolean }
) {
  return useInfiniteQuery({
    queryKey: ['jobChangeProcessesInfinite', searchQuery],
    queryFn: async ({ pageParam = 1 }) => {
      const queryString = buildQueryParams(searchQuery, pageParam);
      const data = await fetchJson<JobChangeProcessesResponse>(
        `/agent/api/job_change_processes.json?${queryString}`
      );
      return data;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_last_page) {
        return undefined;
      }
      return allPages.length + 1;
    },
    initialPageParam: 1,
    enabled: options?.enabled ?? true,
  });
}
